import { OverlayRef } from '@angular/cdk/overlay';
import {
    ClassInjectionData,
    Constructor,
    ModalConfiguration,
    ModalReturnType,
    ModalWrapper,
} from '@ecs-services/modal/modal.helper';
import { Subject } from 'rxjs';

export type ModalCloseEvent<T> = {
    type: 'backdropClick' | 'close';
    data: T;
};

export class ModalRef<C extends Constructor> {
    public readonly component: C;
    public readonly data?: ClassInjectionData<C>;
    public readonly configuration: ModalConfiguration;
    private afterClosed = new Subject<ModalCloseEvent<ModalReturnType<C>>>();

    public get afterClosed$() {
        return this.afterClosed.asObservable();
    }

    public constructor(private overlay: OverlayRef, modalWrapper: ModalWrapper<C>) {
        overlay.backdropClick().subscribe(() => {
            this._close('backdropClick');
        });

        this.component = modalWrapper.component;
        this.data = modalWrapper.data;
        this.configuration = modalWrapper.configuration;
    }

    public close(data?: ModalReturnType<C>) {
        this._close('close', data);
    }

    private _close(type: ModalCloseEvent<ModalReturnType<C>>['type'], data: ModalReturnType<C> = null) {
        this.afterClosed.next({
            type,
            data,
        });
        this.afterClosed.complete();
        this.overlay.dispose();
    }
}
